module.exports = __webpack_public_path__ + "img/registe_info_pic.faf56732.png";